import styles from './ChartLegend.module.css'

export interface LegendItem {
  label: string
  color: string
  value?: string | number
}

interface ChartLegendProps {
  items: LegendItem[]
  className?: string
}

export function ChartLegend({ items, className }: ChartLegendProps) {
  return (
    <div className={`${styles.legend}${className ? ` ${className}` : ''}`}>
      {items.map((item) => (
        <span key={item.label} className={styles.item}>
          <span className={styles.dot} style={{ background: item.color }} />
          <span>{item.label}</span>
          {item.value != null && <span className={styles.value}>{item.value}</span>}
        </span>
      ))}
    </div>
  )
}
